<template>
  <div>
    <el-table
      :data="newPrizeList"
      style="width: 100%; border: 1px solid #f0f0f0;overflow: visible"
      :header-cell-style="{
        background: '#fafafa',
        'text-align': 'left',
      }"
      :cell-style="{ 'text-align': 'left', overflow: 'visible' }"
    >
      <template v-for="(item, index) in tableInfo">
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          :width="setMinWidth(item.width)"
          :align="item.align"
          :min-width="setMinWidth(item.minWidth)"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :key="item.prop"
          :show-overflow-tooltip="
            showOverflowTooltip || item.showOverflowTooltip
          "
          :header-align="item.textAlign"
        >
          <template #header="scope" v-if="item.slotHead">
            <slot :name="item.slotHead" :column="scope.column"></slot>
          </template>
          <template slot-scope="scope">
            <slot
              :name="item.slot"
              :row="scope.row"
              :rowIndex="scope.$index"
              :textWrap="item.textWrap"
              v-if="item.slot"
            ></slot>
            <div v-else-if="item.isPrize">
              <span v-if="item.prop == 'prizeType'">{{
                scope.row.prizeType | prizeType
              }}</span>
              <div class="logo-style" v-if="item.prop == 'logo'">
                <img v-if="scope.row.logo" :src="scope.row.logo" />
              </div>
              <el-input
                v-model="scope.row.title"
                v-if="item.prop == 'title'"
                maxlength="12"
                :disabled="scope.row.prizeType != 3 || (scope.row.isGoodManage ? true : false)"
                show-word-limit
                class="title-input"
                placeholder="请输入"
              ></el-input>
              <el-input
                v-if="item.prop == 'totalAmount'"
                v-model="scope.row.totalAmount"
                @input.native="
                  (e) => (scope.row.totalAmount = checkputn(e, scope.row))
                "
                placeholder="请输入"
                @input="
                  scope.row.totalAmount = getNumberData(
                    1,
                    $event,
                    0,
                    1,
                    999999
                  );
                  prizeNum(scope.row);
                "
                @blur="beAdd(scope.row)"
                :disabled="(isDisabled && !scope.row.minNum) || isDisabled"
              ></el-input>
              <div v-if="item.prop == 'remanentAmount'">
                <el-input
                  v-model="scope.row.remanentAmount"
                  style="width: 80px"
                  disabled
                ></el-input>
                份
              </div>

              <div class="flexc-cen-x" v-if="item.prop == 'operation'">
                <el-button
                  type="text"
                  style="width: auto;padding: 0 !important;"
                  @click="selectGoodFn(scope.row, scope.$index)"
                  :disabled="isDisabled"
                  >选择奖品</el-button
                >
                <el-upload
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :on-success="(res) => uploadLogo(res, scope.row)"
                  :before-upload="(file) => beforeUploadPrize(file)"
                  list-type="picture"
                  ref="uploadRef"
                  :disabled="isDisabled || !scope.row.logo"
                  class="ml12"
                  v-if="isShowUpLoadBtn && !isDisabled"
                >
                  <el-button
                    :disabled="isDisabled || !scope.row.logo"
                    type="text"
                    style="width: auto;padding: 0 !important;"
                  >
                    上传奖品图
                  </el-button>
                </el-upload>
                <el-button
                  type="text"
                  style="width: auto"
                  label="删除"
                  v-if="newPrizeList.length > 1"
                  :disabled="isDisabled"
                  @click="deletePrize(scope.$index)"
                ></el-button>
                <el-button
                  type="text"
                  style="width: auto"
                  v-if="isShowReset && !isDisabled"
                  @click="removePrize(scope.row)"
                  >重置</el-button
                >
                <el-button
                  type="text"
                  style="width: auto"
                  v-if="isDisabled && isShowStock"
                  @click="addStock(scope.row, scope.$index)"
                  >增加库存</el-button
                >
              </div>
            </div>

            <!-- 普通类型内容 -->
            <template v-else>
              <div>
                <!-- 兼容两行 -->
                <div
                  :class="{
                    textHidden: !item.textWrap && !isTowShow,
                    mr6: item.textAlign == 'right' && item.sortable,
                  }"
                  :style="item.textAlign == 'right' ? 'text-align: right;' : ''"
                >
                  {{ scope.row[item.prop] }}
                </div>
              </div>
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <jd-button
      v-if="isShowAdd"
      @click="addPrize"
      :disabled="isDisabled"
      type="blue"
      class="mt12"
    >
      添加奖项（{{ newPrizeList.length }}/{{ maxPrizeCount }}）
    </jd-button>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProductRef"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>
<script>
import selectProduct from "../../select_product";
import addPrizeNum from "../add-prize-num.vue";
export default {
  name: "",
  components: {
    selectProduct,
    addPrizeNum,
  },
  props: {
    // 是否显示添加按钮
    isShowAdd: {
      type: Boolean,
      default: false,
    },
    // 奖品列表
    prizeList: {
      type: Array,
      default: () => [],
    },
    minWidth: {
      type: String,
      default: "90px",
    },
    // 进行中状态
    isDisabled: {
      type: Boolean,
      default: false,
    },
    // 是否显示索引列
    isHasIndex: {
      type: Boolean,
      default: false,
    },
    valueRow: {
      type: Object,
      default: () => ({}),
    },
    // 表格列配置
    tableInfo: {
      type: Array,
      default: () => [],
    },
    // 最大奖品数量
    maxPrizeCount: {
      type: Number,
      default: 4,
    },
    // 是否显示库存按钮
    isShowStock: {
      type: Boolean,
      default: true,
    },
    // 是否显示上传按钮
    isShowUpLoadBtn: {
      type: Boolean,
      default: false,
    },
    showOverflowTooltip: {
      type: Boolean,
      default: false,
    },
    // 是否两行显示
    isTowShow: {
      type: Boolean,
      default: false,
    },
    // 是否显示重置按钮
    isShowReset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
      showSelectProduct: false,
      itemArr: [],
      echoDate: {},
      toAddItem: {},
      isShowAddNum: false,
      prizeIndex: -1,
      JingdouCount: {
        prizeCount: 0,
      },
      newTableInfo: this.tableInfo,
      whitelist: [
        "prizeType",
        "price",
        "title",
        "totalAmount",
        "logo",
        "operation",
      ], //白名单固定字段：奖品类型，值，奖品名称，奖品数量，图片，操作
    };
  },
  computed: {
    newPrizeList: {
      get() {
        return this.prizeList;
      },
      set(val) {
        this.$emit("update:prizeList", val);
      },
    },
    slotList() {
      // 过滤出不在whitelist中的数据为插槽数据
      return this.newTableInfo.filter(
        (item) => !this.whitelist.includes(item.prop)
      );
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "12") {
        result = "专享价";
      } else if (num == "13") {
        result = "令牌";
      }
      return result;
    },
  },
  mounted() {
    this.getRemanentInfo();
  },
  methods: {
    setMinWidth(val) {
      if (val == "minNum") {
        return 140;
      } else if (val == "minText") {
        return 182;
      } else if (val == "minTime") {
        return 160;
      } else {
        return val;
      }
    },
    removePrize(row) {
      row.prizeType = null;
      row.price = null;
      row.title = "";
      row.totalAmount = null;
      row.logo = null;
      row.assetsId = null;
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function() {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    async beforeUploadPrize(file) {
      const status = await this.imgchecked(file, 200, 200);
      if (!status) {
        return false;
      }
    },
    uploadLogo(val, row) {
      row.logo = val.data;
    },
    getRemanentInfo() {
      if (this.isDisabled) {
        this.newTableInfo.splice(this.newTableInfo.length - 2, 1, {
          label: "剩余库存",
          prop: "remanentAmount",
          minWidth: "90px",
          isPrize: true,
        });
      }
    },
    // 删除奖品
    deletePrize(rowIndex) {
      this.newPrizeList.splice(rowIndex, 1);
    },
    // 添加奖品
    addPrize() {
      this.$emit("addPrize");
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.isDisabled) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    getPrizeCommon(data, prizeType) {
      console.log(data, "data111");
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price =
        prizeType == 13 && data.discount == "" ? "" : Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : null;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime || 1;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 12) {
        prizeObj.reducePrice = data.reducePrice;
      }
      return prizeObj;
    },
    // 选择奖品弹窗回调
    getTheData(data, prizeType) {
      let prizeObj = this.getPrizeCommon(data, prizeType);
      if (this.slotList.length) {
        this.slotList.forEach((item) => {
          prizeObj[item.prop] = this.newPrizeList[this.prizeIndex][item.prop];
        });
      }
      this.$set(this.newPrizeList, this.prizeIndex, prizeObj);
      this.showSelectProduct = false;
    },
    //选择奖品弹窗
    selectGoodFn(row, rowIndex) {
      this.JingdouCount.prizeCount = row.totalAmount;
      this.prizeIndex = rowIndex;
      this.echoDate = row;
      this.showSelectProduct = true;
      this.itemArr = this.newPrizeList;
      this.$nextTick(() => {
        this.$refs.selectProductRef.openDialog();
      });
    },
    // 库存更新回调
    confirmAdd(num) {
      this.$set(this.newPrizeList[this.prizeIndex], "totalAmount", Number(num));
      this.isShowAddNum = false;
    },
    // 新增库存
    addStock(row, rowIndex) {
      this.toAddItem = {
        ...row,
        num: row.totalAmount,
      };
      // 选中的奖品下标
      this.prizeIndex = rowIndex;
      this.isShowAddNum = true;
    },
    checkputn(e, row = {}) {
      if (
        row.quantityTotal &&
        row.price &&
        row.totalAmount &&
        row.prizeType == 2
      ) {
        let numTotal = this.$jingdouTotal({
          ...row,
          prizeCount: row.totalAmount,
        });
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.totalAmount;
      }
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.logo-style {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  img {
    width: 80px;
    height: 80px;
  }
}

.title-input {
  width: 240px;
}
.flexc-cen-x {
  display: flex;
  align-items: center;
}

.mr6 {
  margin-right: 6px;
}

.ml12 {
  margin-left: 8px;
}

// 列表行
.textHidden {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
